export function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = resolve;
    img.onerror = reject;
    img.src = url;
  });
}



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardThumbnail/utils/loadImage.js